export const getIsSupportedBrowser = state => state.browserInfo.isSupportedBrowser;
